import type { IFlowButton, FlowType } from '@/types/flowbutton';
import { partCreateHandler } from './partCreateHandler';
import { invoiceProcessHandler } from './invoiceProcessHandler';
import { batchInvoiceHandler } from './batchInvoiceHandler';
import { purchaseOrderHandler } from './purchaseOrderHandler';

// ActionMenuItem defines a single item in the flow button's action menu
export interface ActionMenuItem {
  icon?: string;
  label: string;
  onClick: () => void;
  execute?: () => Promise<void>;
  /** If set, clicking this item opens a dialog pipeline instead of executing inline */
  openDialog?: string;
  /** If set, clicking this item navigates to this URL path (with querystring) */
  navigateTo?: string;
  /** Sub-items rendered as a flyout to the right */
  children?: ActionMenuItem[];
  variant?: 'default' | 'danger';
}

// FlowHandler defines the contract for each flow type
export interface FlowHandler {
  getMenuItems: (button: IFlowButton) => ActionMenuItem[];
}

// Stub handler for unimplemented flow types
const stubHandler: FlowHandler = {
  getMenuItems: () => [
    {
      icon: '🚧',
      label: 'Coming Soon',
      onClick: () => {},
    },
  ],
};

// FLOW_HANDLERS is the registry of all flow type handlers
export const FLOW_HANDLERS: Record<FlowType, FlowHandler> = {
  docflow: stubHandler,
  part_create: partCreateHandler,
  bom_maintain: stubHandler,
  purchase_order: purchaseOrderHandler,
  sale_order: stubHandler,
  invoice_process: invoiceProcessHandler,
  batch_invoice_process: batchInvoiceHandler,
};
